'use strict'

export default class RicFeedbackForm {

  constructor(context, settings) {
    this.step = 0
    this.settings = settings
    this.feedbackType = null
    this.feedbackCompliment = 'Compliment'
    this.feedbackComplaint = 'Complaint'
    this.feedbackSuggestion = 'Suggestion'
    this.responseID = '00N9s000000OLNZ'
    this.firstStepClass = 'ric-feedback-form--form__content-first-step'
    this.secondStepClass = 'ric-feedback-form--form__content-second-step'
    this.recaptchaClass = 'ric-feedback-form--form__captcha'
    this.fieldNameCompliment = '00N9s000000OLNX'
    this.fieldNameComplaint = '00N9s000000OLNY'
    this.fieldNameSuggestion = '00N9s000000OLNW'

    // Setup feedback hover animation.
    let $widget = $('.ric-feedback-widget', context)
    let $ctaEl = $('.ric-feedback-widget__cta', context)
    $ctaEl.on('mouseenter', function () { $(this).parent().addClass('hover') })
    $widget.on('mouseleave', function () { $(this).removeClass('hover') })

    // Setup handler.
    this.ElcomplimentCTA = $('.ric-feedback-widget__choice-compliment', context)
    this.ElcomplaintCTA = $('.ric-feedback-widget__choice-complaint', context)
    this.ElsuggestionCTA = $('.ric-feedback-widget__choice-suggestion', context)
    this.ElcloseButton = $('.ric-feedback-form--form__close', context)

    this.ElcomplimentCTA.on('click', () => this.complimentCTAHandler())
    this.ElcomplaintCTA.on('click', () => this.complaintCTAHandler())
    this.ElsuggestionCTA.on('click', () => this.suggestionCTAHandler())
    this.ElcloseButton.on('click', () => this.hideFeedbackForm())

    // Setup form element.
    this.ElFeedbackForm = $('.ric-feedback-form', context)
    this.ElFeedbackFormSource = this.ElFeedbackForm.find('.ric-feedback-form-source')

    // Setup event listener for dynamic elements.
    this.ElFeedbackForm.on('click', '.ric-feedback-form--btn-cancel', () => this.hideFeedbackForm())
    this.ElFeedbackForm.on('click', '.ric-feedback-form--btn-back', () => this.feedbackFormBackButtonHandler())
    this.ElFeedbackForm.on('click', '.ric-feedback-form--btn-next', (e) => this.feedbackFormNextSubmitButtonHandler(e))
    this.ElFeedbackForm.on('submit', 'form', (e) => this.feedbackFormNextSubmitButtonHandler(e))
    this.ElFeedbackForm.on('change', '#' + this.responseID, () => this.feedbackFormRespondFieldHandler())
    this.ElFeedbackForm.on('blur', 'form .input-group.required .input-element', (e) => this.validateFields(e.target.name))
    this.ElFeedbackForm.on('change', 'form .ric-feedback-form--form__captcha .g-recaptcha-response', (e) => this.validateFields(e.target.name))
  }

  complimentCTAHandler() {
    this.feedbackType = this.feedbackCompliment
    this.showFeedbackForm()
    this.populateTitle('Compliment')
    this.renderFields()
  }

  complaintCTAHandler() {
    this.feedbackType = this.feedbackComplaint
    this.showFeedbackForm()
    this.populateTitle('Complaint')
    this.renderFields()
  }

  suggestionCTAHandler() {
    this.feedbackType = this.feedbackSuggestion
    this.showFeedbackForm()
    this.populateTitle('Suggestion')
    this.renderFields()
  }

  feedbackFormNextSubmitButtonHandler(e) {
    const hasError = this.validateFields()

    if (hasError) {
      return !hasError
    }

    if (this.step === 1) {
      this.showSecondStep()
    }

    if (this.step === 2) {
      // We need to combine first name and last name.
      const firstName = this.ElFeedbackForm.find('[name="firstName"]').val()
      const lastName = this.ElFeedbackForm.find('[name="lastName"]').val()
      this.ElFeedbackForm.find('[name="name"]').attr('value', firstName + ' ' + lastName)

      // Update description to be same as the first field of each type.
      let desc = ''
      if (this.feedbackType === this.feedbackCompliment) {
        desc = this.ElFeedbackForm.find('[name="' + this.fieldNameCompliment + '"]').val()
      }
      else if (this.feedbackType === this.feedbackComplaint) {
        desc = this.ElFeedbackForm.find('[name="' + this.fieldNameComplaint + '"]').val()
      }
      else {
        desc = this.ElFeedbackForm.find('[name="' + this.fieldNameSuggestion + '"]').val()
      }
      this.ElFeedbackForm.find('[name="description"]').attr('value', desc)

      return true
    }

    return false
  }

  validateFirstStepFields(fieldName) {
    let hasError = false
    let renderer = this

    this.ElFeedbackForm.find('.ric-feedback-form--form__content-first-step .input-element').each(function () {
      // Skip the looping if the fieldName is provided.
      if (fieldName !== null && $(this).attr('name') !== fieldName) {
        hasError = false

        return true
      }

      let fieldError = false
      if ($(this).attr('required') && $(this).val().trim().length === 0) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($(this), 'Complete this field')
      }

      if (renderer.textareaLengthExceeded($(this), 3000)) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($(this), 'The value is more than 3000 characters.')
      }

      if (!fieldError) {
        renderer.removeErrorMessageField($(this))
      }
    })

    return hasError
  }

  validateCommonFields(fieldName) {
    fieldName = typeof fieldName !== 'undefined' ? fieldName : null

    let hasError = false
    let renderer = this

    this.ElFeedbackForm.find('.' + this.secondStepClass + ' > .input-group .input-element').each(function () {
      let $fieldEl = $(this)
      let fieldError = false

      // Skip the looping if the fieldName is provided.
      if (fieldName !== null && $fieldEl.attr('name') !== fieldName) {
        hasError = false
        fieldError = false

        return true
      }

      if ($fieldEl.attr('required') && $fieldEl.val().trim().length === 0) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($(this), 'Complete this field')
      }

      if (renderer.textareaLengthExceeded($fieldEl, 3000)) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($fieldEl, 'The value is more than 3000 characters.')
      }

      if (!fieldError) {
        renderer.removeErrorMessageField($fieldEl)
      }

      // Validate response fields if the Would you like a response? field is checked.
      if ($fieldEl.attr('id') === renderer.responseID && $fieldEl.prop('checked')) {
        renderer.ElFeedbackForm.find('.ric-feedback-form--wrapper .response-field-wrappers .input-element').each(function () {
          console.log(fieldName, $(this).attr('name'))

          // Skip the looping if the fieldName is provided.
          if (fieldName !== null && $(this).attr('name') !== fieldName) {
            hasError = false
            fieldError = false

            return true
          }

          fieldError = false
          if ($(this).attr('required') && $(this).val().trim().length === 0) {
            hasError = true
            fieldError = true
            renderer.populateErrorMessageField($(this), 'Complete this field')
          }

          if (!fieldError && $(this).attr('type') === 'email' && !validateEmail($(this).val().trim())) {
            hasError = true
            fieldError = true
            renderer.populateErrorMessageField($(this), 'You have entered an invalid email format.')
          }

          if (!fieldError) {
            renderer.removeErrorMessageField($(this))
          }
        })
      }
    })

    return !hasError
  }

  validateFields(fieldName) {
    const validateEmail = (email) => {
      return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    }

    fieldName = typeof fieldName !== 'undefined' ? fieldName : null
    let fields = []
    let hasError = false
    let renderer = this
    const recaptchaFieldName = 'g-recaptcha-response'

    if (this.step === 1) {
      this.ElFeedbackForm.find('.' + this.firstStepClass + ' .input-element').each(function () {
        if (fieldName !== null && fieldName !== $(this).attr('name')) {
          return true
        }

        fields.push($(this).attr('name'))
      })
    }

    if (this.step === 2) {
      this.ElFeedbackForm.find('.' + this.secondStepClass + ' .input-group .input-element').each(function () {
        if (fieldName !== null && fieldName !== $(this).attr('name')) {
          return true
        }

        fields.push($(this).attr('name'))
      })

      // Register recaptcha to the validator.
      const captcha = this.ElFeedbackForm.find('[name="g-recaptcha-response"]');
      if (captcha.length && (fieldName === null || fieldName === recaptchaFieldName)) {
        fields.push('g-recaptcha-response')
      }
    }

    // Do the validation to the field.
    fields.forEach((item) => {
      let $fieldEl = this.ElFeedbackForm.find('form [name="' + item + '"]')
      let fieldError = false

      if ($fieldEl.attr('required') && $fieldEl.val().trim().length === 0) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($fieldEl, 'Complete this field')
      }

      if (renderer.textareaLengthExceeded($fieldEl, 3000)) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($fieldEl, 'The value is more than 3000 characters.')
      }

      if (!fieldError && $fieldEl.attr('type') === 'email' && $fieldEl.val().trim().length > 0 && !validateEmail($fieldEl.val().trim())) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($fieldEl, 'You have entered an invalid email format.')
      }

      if ($fieldEl.attr('name') === recaptchaFieldName && $fieldEl.val().length === 0) {
        hasError = true
        fieldError = true
        renderer.populateErrorMessageField($fieldEl, 'Invalid captcha')
      }

      if (!fieldError) {
        renderer.removeErrorMessageField($fieldEl)
      }
    })

    return hasError
  }

  feedbackFormBackButtonHandler() {
    this.showFirstStep()
  }

  feedbackFormRespondFieldHandler() {
    // Check if the response checkbox is ticked.
    const wrapper = '.ric-feedback-form--wrapper .response-field-wrappers .input-group'
    if (this.ElFeedbackForm.find('#' + this.responseID).prop('checked')) {
      // Make the contact fields mandatory.
      this.ElFeedbackForm.find(wrapper).each(function () {
        $(this).addClass('required')
        $(this).find('.input-element').attr('required', 'required')
      })
    } else {
      let renderer = this
      this.ElFeedbackForm.find(wrapper).each(function () {
        $(this).removeClass('required')
        const $fieldEl = $(this).find('.input-element')
        $fieldEl.removeAttr('required')
        renderer.removeErrorMessageField($fieldEl)
      })
    }
  }

  showFeedbackForm() {
    this.ElFeedbackForm.addClass('show')

    let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (w <= 992) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }

  hideFeedbackForm() {
    this.ElFeedbackForm.removeClass('show')
    this.ElFeedbackForm.find('.ric-feedback-form--form__footer').show()
    this.step = 0
  }

  showFirstStep() {
    this.ElFeedbackForm.find('.' + this.secondStepClass).hide()
    this.ElFeedbackForm.find('.' + this.recaptchaClass).hide()
    this.ElFeedbackForm.find('.btn-second-step').hide()

    this.ElFeedbackForm.find('.' + this.firstStepClass).show()
    this.ElFeedbackForm.find('.btn-first-step').show()

    this.step = 1
  }

  showSecondStep() {
    this.ElFeedbackForm.find('.' + this.firstStepClass).hide()
    this.ElFeedbackForm.find('.btn-first-step').hide()

    this.ElFeedbackForm.find('.' + this.secondStepClass).show()
    this.ElFeedbackForm.find('.' + this.recaptchaClass).show()
    this.ElFeedbackForm.find('.btn-second-step').show()

    this.feedbackFormRespondFieldHandler()

    this.step = 2
  }

  textareaLengthExceeded($el, length) {
    return !!($el.is('textarea') && $el.val().trim().length > length);
  }

  removeErrorMessageField($el) {
    if ($el.is('select')) {
      $el = $el.parent()
    }

    if ($el.next().hasClass('input-error-message')) {
      $el.next().remove()
      $el.removeClass('error')
    }
  }

  populateErrorMessageField($el, msg) {
    if ($el.is('select')) {
      $el = $el.parent()
    }

    if ($el.next().hasClass('input-error-message')) {
      $el.next().html(msg)
    } else {
      $el.after(`<div class="input-error-message">${msg}</div>`)
    }
    $el.addClass('error')
  }

  populateTitle(title) {
    this.ElFeedbackForm.find('.ric-feedback-form--form__title').text(title)
  }

  populateContent(htmlContent) {
    this.ElFeedbackForm.find('.ric-feedback-form--form__content').html(htmlContent)
  }

  generateFields(feedbackType) {
    let firstStepHTML = ''
    let secondStepHTML = ''
    let fieldHTML = ''

    firstStepHTML = this.ElFeedbackFormSource.find('.' + feedbackType).html()
    if (firstStepHTML.trim().length > 0) {
      fieldHTML += `<div class="${this.firstStepClass}">${firstStepHTML}</div>`
    }

    // Always add the common field for 2nd screen.
    secondStepHTML = this.ElFeedbackFormSource.find('.commons').html()
    if (secondStepHTML.trim().length > 0) {
      fieldHTML += `<div class="${this.secondStepClass}"">${secondStepHTML}</div>`
    }

    // Update dynamic value.
    let subject = ''
    if (this.feedbackType === this.feedbackCompliment) {
      subject = 'What went well?'
    } else if (this.feedbackType === this.feedbackComplaint) {
      subject = 'What went wrong?'
    } else {
      subject = 'How can we improve?'
    }
    this.ElFeedbackForm.find('[name="subject"]').attr('value', subject)
    this.ElFeedbackForm.find('[name="type"]').attr('value', this.feedbackType)

    return fieldHTML
  }

  renderFields() {
    this.populateContent(this.generateFields(this.feedbackType))
    this.showFirstStep()
  }

  showErrorSuccessPopup(title, htmlContent) {
    this.populateTitle(title)
    this.populateContent(htmlContent)
    this.ElFeedbackForm.find('.ric-feedback-form--form__footer').hide()
  }

}
